export default () => {
    const prefooter = $("<div/>", { class: "pre-footer" }).insertBefore("footer");
    $("<img>", {
        src: "/user/documents/upload/img/footer_kone.jpg",
    }).appendTo(prefooter);
    $("#footer .site-name img").attr(
        "src",
        "/user/documents/upload/img/kone-logo-footer.png"
    );
};